import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import style from './style/stars.scss';

/**
 * Horizontal score bar with sections made up of stars
 *
 * @example
 * <Stars
 *     scoreValue={ scoreValue }
 *     scoreDivisionMinimum={ scoreDivisionMinimum }
 *     scoreMax={ scoreMax }
 *     classes={{
 *         root: classes.root,
 *         header: classes.header,
 *         active: classes.active,
 *         inactive: classes.inactive,
 *     }}
 *     scoreLevelDescription={ scoreLevelDescription }
 *     label= { 'a label' }
 * />
 */
export default class Stars extends Component {
    constructor(props) {
        super(props);

        this.state = {
            scoreValue: this.props.scoreValue
        };
    }

    componentDidUpdate() {
        if (this.props.scoreValue !== this.state.scoreValue) {
            this.setState({
                scoreValue: this.props.scoreValue
            });
        }
    }

    render() {
        const { scoreDivisionMinimum, scoreMax, label, classes, scoreLevelDescription } = this.props;

        if (this.state.scoreValue % scoreDivisionMinimum || this.state.scoreValue > scoreMax) {

            /* there is an error with the supplied score, it can not be divided or it is too big */
            return null;
        }

        const output = [];
        let currentStar = 0;
        let elementKeyIndex = 0;

        // add whole stars
        for (currentStar; currentStar < parseInt(this.state.scoreValue, 0); currentStar++) {
            output.push(
                <li
                    key={ `score${currentStar}-${++elementKeyIndex}` }
                    className={ `${style.star__active} ${classes.active ? classes.active : ''}` }
                >
                    <FontAwesomeIcon icon={ ['fas', 'star'] } />
                </li>
            );
        }

        // add half stars if needed
        if (this.state.scoreValue - currentStar > 0) {
            output.push(
                <li
                    key={ `score${currentStar}-${++elementKeyIndex}` }
                    className={ `${style.star__active} ${style.cutRight} ${classes.active ? classes.active : ''}` }
                >
                    <FontAwesomeIcon icon={ ['fas', 'star'] } />
                </li>
            );
            output.push(
                <li
                    key={ `score${currentStar}-${++elementKeyIndex}` }
                    className={ `${style.star__inactive} ${style.cutLeft} ${classes.inactive ? classes.inactive : ''}` }
                >
                    <FontAwesomeIcon icon={ ['fas', 'star'] } />
                </li>
            );

            currentStar++;
        }

        // add empty stars
        for (currentStar; currentStar < scoreMax; currentStar++) {
            output.push(
                <li
                    key={ `score${currentStar}-${++elementKeyIndex}` }
                    className={ `${style.star__inactive} ${classes.inactive ? classes.inactive : ''}` }
                >
                    <FontAwesomeIcon icon={ ['fas', 'star'] } />
                </li>
            );
        }

        return (
            <section className={ `${style.stars} ${classes.root ? classes.root : ''}` }>
                <header className={ `${classes.header}` }>{ label }</header>
                <ul>
                    { output }
                </ul>
                <p className={ style.score_level_description }>{ scoreLevelDescription }</p>
            </section>
        );
    }
}

Stars.propTypes = {
    scoreDivisionMinimum: PropTypes.number,
    scoreMax: PropTypes.number,
    classes: PropTypes.shape({
        root: PropTypes.string,
        header: PropTypes.string,
        active: PropTypes.string,
        inactive: PropTypes.string
    }),
    scoreLevelDescription: PropTypes.string,
    scoreValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Stars.defaultProps = {
    scoreDivisionMinimum: 0.5,
    scoreMax: 5,
    classes: {
        root: '',
        header: '',
        active: '',
        inactive: ''
    },
    scoreLevelDescription: ''
};
